/**
 * Organization membership roles (bitwise values for efficient permission storage)
 * These roles are organization-specific and stored in membership claims (m[].c)
 */
export enum MembershipRoles {
  Pilot = 1 << 0,              // 1
  PilotInCharge = 1 << 1,      // 2
  Owner = 1 << 2,              // 4
  ChiefSupervisor = 1 << 3,    // 8
  Farmer = 1 << 4,             // 16
}
